import { TextAreaAi, useStartNewChat } from '@mint-lib/ai-chat';
import { Chat } from '@mint-sdk/api-ai-assistant';

import { useAiSidebarContext } from '../../../context.jsx';
import SidebarHeader from '../../molecules/SidebarHeader/SidebarHeader.jsx';
import SuggestionOriginDetails from '../../molecules/SuggestionOriginDetails/SuggestionOriginDetails.jsx';

const SuggestionPreview = () => {
  const { startNewChat } = useStartNewChat();
  const { setCurrentChat, selectedSuggestion } = useAiSidebarContext();

  const handleSendMessage = async (text: string) => {
    if (!selectedSuggestion) {
      return;
    }

    const metadata: Chat.UserMetadataSchemaType = {
      reco: {
        recoId: selectedSuggestion.id,
      },
    };

    const chat = await startNewChat(
      {
        scopeType: 'ENTITY',
        scopePath: '/notification-hub',
        entityType: 'suggestion',
        entityId: String(selectedSuggestion.id),
      },
      { text, metadata },
    );

    setCurrentChat(chat.chatSessionId);
  };
  return (
    <div
      className="flex h-full [scrollbar-width:none] flex-col justify-between overflow-y-auto"
      data-testid="suggestion-preview"
    >
      <div data-testid="suggestion-origin-details">
        <SidebarHeader isWithSidebar />
        <SuggestionOriginDetails />
      </div>
      <div
        className="sticky bottom-0 w-full bg-ui-primary pb-2"
        data-testid="preview-chat-input"
      >
        <TextAreaAi handleSendQuestion={handleSendMessage} />
      </div>
    </div>
  );
};

export { SuggestionPreview };
